import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import { decryptAES, encryptAES } from '../util/cipher'
import { clearProfileData } from '../redux/action/profile'
import { useState, useRef } from 'react'

const useAxiosInterceptor = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const [openDialog, setOpenDialog] = useState(false)
    const [alertMessage, setAlertMessage] = useState('')
    const [isExpiredSession, setIsExpiredSession] = useState(false)

    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            (response) => response,
            async (error) => {
                const originalRequest = error.config

                if (error.response?.status === 401 && !originalRequest._retry) {
                    originalRequest._retry = true

                    await callServiceReLogin(originalRequest)
                }

                if (!(error instanceof Error)) {
                    throw new Error(String(error))
                }
                throw error
            },
        )

        // cleanup
        return () => axios.interceptors.response.eject(interceptor)
    }, [dispatch, history])

    useEffect(() => {
        callServiceAppConfig()
    }, [])

    const callServiceReLogin = async (originalRequest: any) => {
        try {
            const url = `${process.env.REACT_APP_API}/api/auth/relogin`
            let localRefId =
                globalThis.sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_PROFILE}`) ??
                globalThis.localStorage.getItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)

            const refId = localRefId ? JSON.parse(decryptAES(localRefId)) : null

            if (refId) {
                const reqParams = {
                    accessToken: refId.accessToken,
                    refreshToken: refId.refreshToken,
                }

                const result = await axios.post(url, reqParams)

                globalThis.sessionStorage.clear()
                globalThis.localStorage.removeItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)

                if (result.status === 200) {
                    if (result.data.success) {
                        const hashCookieToken = encryptAES(
                            JSON.stringify({ ...result.data, isRememberLogin: refId.isRememberLogin }),
                        )

                        if (refId.isRememberLogin) {
                            globalThis.localStorage.setItem(`${process.env.REACT_APP_TOKEN_PROFILE}`, hashCookieToken)
                        }

                        globalThis.sessionStorage.setItem(`${process.env.REACT_APP_TOKEN_PROFILE}`, hashCookieToken)
                        globalThis.sessionStorage.setItem(
                            `${process.env.REACT_APP_ACCESS_TOKEN_NBTC}`,
                            result.data.accessToken,
                        )

                        return await axios(originalRequest)
                    } else {
                        setIsExpiredSession(true)
                        dispatch(clearProfileData())
                        setAlertMessage(result.data.errMessage)
                        setOpenDialog(true)
                    }
                } else {
                    setIsExpiredSession(false)
                    setAlertMessage('เกิดข้อผิดพลาด')
                    setOpenDialog(true)
                    // globalThis.sessionStorage.clear()
                    // globalThis.localStorage.removeItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
                    // globalThis.location.href = `${process.env.PUBLIC_URL}/?error=sessionexpired`
                    //history.push('/?result=sessionexpired')
                }
            } else {
                dispatch(clearProfileData())
                globalThis.sessionStorage.clear()
                globalThis.localStorage.removeItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
                history.push('/')
            }
        } catch (retryError) {
            if (!(retryError instanceof Error)) {
                throw new Error(String(retryError))
            }
            throw retryError
        }
    }

    const callServiceAppConfig = async () => {
        const storage2FA = process.env.REACT_APP_2FA_STORAGE
        globalThis.localStorage.removeItem(`${storage2FA}`)
        try {
            const url = `${process.env.REACT_APP_API}/api/appconfig`
            const result = await axios.get(url)
            globalThis.localStorage.setItem(`${storage2FA}`, result.data.use2fa)
        } catch (err) {
            console.log(err)
            globalThis.localStorage.removeItem(`${storage2FA}`)
        }
    }

    return {
        openDialog,
        setOpenDialog,
        alertMessage,
        setAlertMessage,
        isExpiredSession,
        setIsExpiredSession,
    }
}

export default useAxiosInterceptor
